import React from 'react';

import Table from 'components/shared/table';

const ArchiveTableFooter = ({
  archivables,
  loading,
  setPage,
  page,
  pageCount,
}) => {
  if (loading || !archivables.length || pageCount <= 1) return null;

  return (
    <Table.Footer>
      <Table.Pagination
        onPageChange={setPage}
        page={page}
        pageCount={pageCount}
      />
      {pageCount > 1 && (
        <span className="fs-i fz-16 w-fill d-f jc-e ai-c">
          {t('common.number_rows_per_page', { number: 50 })}
        </span>
      )}
    </Table.Footer>
  );
};

export default ArchiveTableFooter;
